module.exports = __webpack_public_path__ + "img/american-credit-google-review-luis-hernandez.e94fefd.webp";